import type {
	AnalyticsEvent,
	AnalyticsOptions,
	AnalyticsParams,
	AnalyticsPlatform,
} from "./types";

/**
 * Google Ads / GA4 platform stub.
 *
 * Wire this up by:
 *   1. Adding VITE_GOOGLE_ADS_ID (or VITE_GA4_MEASUREMENT_ID) to the env files.
 *   2. Filling in `init()` to load gtag.js and call `gtag('config', id)`.
 *   3. Filling in `track()` to map our events to gtag's taxonomy
 *      (e.g. initiate_checkout -> begin_checkout, purchase -> purchase).
 *
 * Until then this is a no-op so the orchestrator can ship without breaking.
 */

declare global {
	interface Window {
		gtag?: (...args: unknown[]) => void;
		dataLayer?: unknown[];
	}
}

const EVENT_MAP: Record<AnalyticsEvent, string> = {
	page_view: "page_view",
	view_content: "view_item",
	add_to_cart: "add_to_cart",
	initiate_checkout: "begin_checkout",
	lead: "generate_lead",
	complete_registration: "sign_up",
	purchase: "purchase",
};

function isEnabled() {
	return Boolean(import.meta.env.VITE_GOOGLE_ADS_ID);
}

export const googlePlatform: AnalyticsPlatform = {
	init() {
		if (!isEnabled()) return;
		// TODO: load gtag.js and configure with VITE_GOOGLE_ADS_ID
	},

	track(
		_event: AnalyticsEvent,
		_params?: AnalyticsParams,
		_options?: AnalyticsOptions
	) {
		if (!isEnabled() || typeof window === "undefined") return;
		// TODO: window.gtag?.("event", EVENT_MAP[_event], params)
		void EVENT_MAP;
	},
};
